import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ variant = 'default', className = '' }) => {
  const textColor = variant === 'light' ? 'text-white' : 'text-dark-900';
  const subTextColor = variant === 'light' ? 'text-dark-300' : 'text-dark-400';

  return (
    <Link to="/" className={`flex items-center gap-3 group ${className}`}>
      <div className="relative">
        <div className="w-11 h-11 rounded-full bg-gradient-to-br from-athletic-500 to-athletic-700 flex items-center justify-center transform group-hover:scale-105 transition-transform shadow-button">
          <span className="font-display font-bold text-white text-base tracking-tight leading-none">CFR</span>
        </div>
      </div>
      <div className="flex flex-col leading-none">
        <span className={`font-display font-bold text-2xl tracking-tight ${textColor} transition-colors`}>
          Cycle <span className="text-athletic-600">Forge</span> Ride
        </span>
        <span className={`text-[10px] font-semibold uppercase tracking-[0.28em] mt-0.5 ${subTextColor} transition-colors`}>
          Bike Parts &amp; Supplies
        </span>
      </div>
    </Link>
  );
};

export default Logo;
